const agentReducer = ( state = [], action ) => {
  return state;
};

export { agentReducer };
